import { useEffect, useState } from "react";

// 新しい版を公開したのに、開きっぱなしのアプリ（ホーム画面のアプリ・スマホのタブ）が古い画面のまま動き続けるのを防ぐ。
// アプリに戻ってきたとき（と10分ごと）に最新の index.html を見て、読み込んでいる本体のファイル名が変わっていたら案内を出す。
// 入力途中の内容を消さないよう、自動では再読み込みせず「更新」を押してもらう。
function currentEntry(): string | null {
  const el = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/index-"]');
  return el ? new URL(el.src).pathname : null;
}

export default function UpdateBanner() {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    const mine = currentEntry();
    if (!mine) return; // 開発サーバーなど
    let stop = false;
    const check = async () => {
      if (stop || document.visibilityState !== "visible") return;
      try {
        const html = await (await fetch("/", { cache: "no-store" })).text();
        const m = html.match(/\/assets\/index-[^"']+\.js/);
        if (m && m[0] !== mine) setStale(true);
      } catch { /* オフライン等は次回 */ }
    };
    const onVis = () => { if (document.visibilityState === "visible") check(); };
    document.addEventListener("visibilitychange", onVis);
    const t = setInterval(check, 10 * 60_000);
    return () => { stop = true; document.removeEventListener("visibilitychange", onVis); clearInterval(t); };
  }, []);
  if (!stale) return null;
  return (
    <div role="status" className="fixed inset-x-0 bottom-16 z-50 mx-auto flex w-fit max-w-[92vw] items-center gap-3 rounded-full bg-gray-900 px-4 py-2 text-sm text-white shadow-lg lg:bottom-6">
      <span>新しいバージョンがあります</span>
      <button className="rounded-full bg-white px-3 py-1 text-xs font-semibold text-gray-900" onClick={() => location.reload()}>更新</button>
    </div>
  );
}
